import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=57f07d50&scoped=true&web=true&"
import script from "./Management.vue?vue&type=script&lang=ts&"
export * from "./Management.vue?vue&type=script&lang=ts&"
import style0 from "./Management.vue?vue&type=style&index=0&id=57f07d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f07d50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
